import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../Contexts/LanguageContext"; // Import Language Context

const Navbar = () => {
    const { language, toggleLanguage } = useLanguage(); // Use global language state
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20); // You can tweak the threshold here
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <nav className={`fixed top-0 left-0 w-full flex items-center justify-between py-4 px-6 z-50 shadow-md transition-all duration-300 
            ${scrolled ? "bg-indigo-500 bg-opacity-100" : "bg-indigo-500 bg-opacity-60"}
        `}>
            {/* Left Side - Mobile: Hamburger | Desktop: Back Icon + Menu */}
            <div className="flex items-center space-x-4">
                {/* Hamburger Menu (Mobile) */}
                <button
                    onClick={() => setIsMenuOpen(true)}
                    className="md:hidden focus:outline-none"
                >
                    <Menu className="w-7 h-7" />
                </button>

                {/* Desktop Menu Options */}
                <div className="hidden md:flex space-x-6">
                    <Link to="/about" className="hover:underline">About</Link>
                    <Link to="/news" className="hover:underline">News</Link>
                    <Link to="/testimonials" className="hover:underline">Testimonials</Link>
                    <Link to="/contact" className="hover:underline">Contact</Link>
                </div>
            </div>

            {/* Center Logo */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <img
                    src="/hodgiesLogoDark.png"
                    alt="Logo"
                    className="w-12 h-12 object-contain"
                />
            </div>

            {/* Right Side - Language Toggle */}
            <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium hidden sm:block">
                        {language} {/* Displays the current language */}
                    </span>
                    <button
                        onClick={toggleLanguage}
                        className={`w-12 h-6 rounded-full flex items-center ${language === "Spanish" ? "bg-green-500" : "bg-gray-400"} transition-colors duration-300`}
                    >
                        <span
                            className={`w-5 h-5 bg-white rounded-full shadow-md transform ${language === "Spanish" ? "translate-x-6" : "translate-x-1"} transition-transform duration-300`}
                        ></span>
                    </button>
                </div>
            </div>

            {/* Sidebar Overlay Menu (Mobile Only) */}
            {isMenuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex">
                    {/* Side Menu */}
                    <div className="w-3/4 h-full bg-white shadow-lg transform transition-all duration-300">
                        {/* Header Image (Now Half the Height) */}
                        <div className="relative w-full h-20">
                            <img
                                src="/images/digital1.jpg"
                                alt="Header"
                                className="w-full h-full object-cover"
                            />
                            {/* Close Button Inside Sidebar */}
                            <button
                                onClick={() => setIsMenuOpen(false)}
                                className="absolute top-2 right-4 bg-white p-2 rounded-full shadow-md"
                            >
                                <X className="w-6 h-6 text-black" />
                            </button>
                        </div>

                        {/* Sidebar Content */}
                        <div className="mt-6 p-6 space-y-6">
                            <Link to="/" className="block text-lg font-semibold hover:underline">Home</Link>
                            <Link to="/about" className="block text-lg font-semibold hover:underline">About</Link>
                            <Link to="/news" className="block text-lg font-semibold hover:underline">News</Link>
                            <Link to="/pricing" className="block text-lg font-semibold hover:underline">Pricing</Link>
                            <Link to="/contact" className="block text-lg font-semibold hover:underline">Contact</Link>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
